import React, { Fragment, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { isBlank, notBlank } from "../../util/ext";
import { equals } from "ramda";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  paper: {
    height: 150,
  },
}));

const ModuleAutocomplete = props => {
  const {
    // onChange,
    label,
    modules,
    selectedModule,
    setSelectedModule,
  } = props;

  const classes = useStyles();

  // const [selectedModule, setSelectedModule] = useState(null);

  const handleModuleSelect = useCallback(
    (_event, module) => {
      console.log(module);

      setSelectedModule(isBlank(module) ? {} : module);
      // onChange(_event, module ? module : null);
    },
    // [onChange],
    [setSelectedModule],
  );

  return (
    <Fragment>
      {modules.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <Autocomplete
          style={{ flexGrow: 1 }}
          classes={{
            paper: classes.paper,
          }}
          options={modules}
          value={selectedModule || ""}
          clearOnBlur={false}
          getOptionLabel={module => {
            return notBlank(module) ? module.name : "";
          }}
          getOptionSelected={(opt, val) => {
            return isBlank(val) || equals(opt.id, val.id);
          }}
          // getOptionDisabled={opt => {
          //   return any(module => equals(module.moduleId, opt.moduleId))(
          //     disabledModules,
          //   );
          // }}
          filterOptions={(options, state) => {
            if (!options || isBlank(state.inputValue)) {
              return options;
            }

            const filterRegex = new RegExp(`${state.inputValue}`, "i");
            return options.filter(
              o => o.name.match(filterRegex) || o.id.match(filterRegex),
            );
          }}
          onChange={handleModuleSelect}
          renderInput={params => {
            params.inputProps["aria-autocomplete"] = "none";
            params.inputProps["id"] = null;
            return (
              <TextField
                {...params}
                type="text"
                name={"module-" + Math.random()}
                variant="standard"
                // InputLabelProps={{ shrink: false }}
                label={label}
              />
            );
          }}
        />
      )}
    </Fragment>
  );
};

export default ModuleAutocomplete;
